import JockeyTrainerReduction, {
  JockeyTrainerReductionGroupRow,
} from './JockeyTrainerReduction';
import TrainerAbstraction from './TrainerAbstraction';

// ---------------------------------------- JockeyReduction ----------------------------------------

export default class TrainerReduction extends JockeyTrainerReduction {
  constructor() {
    super(...arguments);
    this.initialize('trainerGroups', TrainerReductionGroupRow);
  }
}
// ---------------------------------------- JockeyReductionGroupRow ----------------------------------------
class TrainerReductionGroupRow extends JockeyTrainerReductionGroupRow {
  constructor() {
    super(...arguments);
    this.initialize('trainerRows', TrainerAbstraction);
  }
}
